import type {FC} from 'react';
import {DeleteButton, Edit, ReferenceInput, required, SelectInput, SimpleForm, Toolbar} from 'react-admin';

const ToolbarDeleteOnly: FC = (props) => (
  <Toolbar {...props}>
    <DeleteButton />
  </Toolbar>
);

export const ForestMassSpeciesEdit: FC = () => (
  <Edit>
    <SimpleForm toolbar={<ToolbarDeleteOnly />}>
      <ReferenceInput source="forestMassUuid" reference="forest-masses">
        <SelectInput optionText="code" validate={[required()]} />
      </ReferenceInput>
      <ReferenceInput source="speciesUuid" reference="species">
        <SelectInput optionText="nameKey" validate={[required()]} />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);
